import { render } from "./dictBasical.vue?vue&type=template&id=619e01e8&scoped=true"
import script from "./dictBasical.vue?vue&type=script&lang=js"
export * from "./dictBasical.vue?vue&type=script&lang=js"

import "./dictBasical.vue?vue&type=style&index=0&id=619e01e8&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619e01e8"]])

export default __exports__